/** '$1.9M', '$2.0M'. Always one decimal unless told otherwise. */
export function fmtMillions(n: number, digits = 1): string {
  const sign = n < 0 ? '-' : '';
  return `${sign}$${(Math.abs(n) / 1e6).toFixed(digits)}M`;
}

/** '+$0.20M' or '-$7.82M'. */
export function fmtSignedMillions(n: number, digits = 2): string {
  if (n === 0) return `$${(0).toFixed(digits)}M`;
  return `${n > 0 ? '+' : '-'}$${(Math.abs(n) / 1e6).toFixed(digits)}M`;
}

/** Thousands with a K suffix, '$144K'. */
export function fmtThousands(n: number): string {
  return `$${Math.round(n / 1e3).toLocaleString('en-US')}K`;
}

/** Price per fixture with cents, '$83.70'. */
export function fmtPerUnit(n: number, digits = 2): string {
  return `$${n.toFixed(digits)}`;
}

/** Fixture counts: 130,000 gives '130,000 fixtures'. */
export function fmtFixtures(n: number): string {
  return `${Math.round(n).toLocaleString('en-US')} fixtures`;
}

/** '$11.58M' for millions (two decimals), '$540K' below that. */
export function fmtUsdCompact(n: number, millionDigits = 2): string {
  if (Math.abs(n) >= 1e6) return fmtMillions(n, millionDigits);
  return fmtThousands(n);
}
